import { motion } from "framer-motion";
import { MapPin, CheckCheck, BarChart3 } from "lucide-react";
import { useLang } from "@/lib/i18n";

const stepsMeta = [
  { n: "01", icon: MapPin },
  { n: "02", icon: CheckCheck },
  { n: "03", icon: BarChart3 },
];

export default function HowItWorks() {
  const { t } = useLang();
  const steps = stepsMeta.map((s, i) => ({ ...s, ...t.how.steps[i] }));
  return (
    <section id="how" className="py-24 md:py-32 border-b border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <p className="font-mono-pw uppercase text-xs tracking-[0.3em] text-[#E6FF00] mb-5">{t.how.overline}</p>
            <h2 className="font-anton uppercase leading-[0.9] text-5xl md:text-7xl">
              {t.how.headA} <br /> {t.how.headB}
            </h2>
          </div>
          <p className="font-mono-pw uppercase text-xs tracking-[0.2em] text-white/40 max-w-xs md:text-right">
            {t.how.note}
          </p>
        </div>

        <div className="grid md:grid-cols-3 border-t border-l border-white/10">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`step-${s.n}`}
                className="group relative border-r border-b border-white/10 p-8 md:p-10 min-h-[320px] flex flex-col justify-between hover:bg-[#111111] transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="font-anton text-7xl md:text-8xl text-white/10 group-hover:text-[#E6FF00] transition-colors duration-300 leading-none">
                    {s.n}
                  </span>
                  <Icon className="text-[#E6FF00] mt-2" size={30} strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-anton uppercase text-3xl md:text-4xl mb-4">{s.title}</h3>
                  <p className="font-body text-white/60 leading-relaxed text-sm">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
